module.exports = __webpack_public_path__ + "static/media/lds-logo_zh-hans.c05d7f4d.svg";